import { api } from './client'

export type EmbalagemDaFamilia = {
  /** `padrao` para o geral; o nome da família para o resto. */
  familia: string
  /** `CxLxA` ou `CxLxA/K`, ou nulo quando ninguém cadastrou. */
  valor: string | null
  /**
   * 🔴 Ninguém escreveu — e é exatamente isto que a fronteira do frete lê
   * (demanda 076 §2.3). Enquanto for `true`, o assistente **não cota** frete
   * para esta família: nenhum humano da Rio DG conferiu a caixa.
   */
  deFabrica: boolean
  atualizadoEm: string | null
  atualizadoPor: string | null
}

/**
 * O multiplicador aplicado ao frete cotado antes de ele chegar ao cliente
 * (demanda 161 · decisão D5 de 02/09: **× 1,2**, para cobrir a bitributação).
 */
export type MultiplicadorDoFrete = {
  /** O que está VALENDO — `1,2000`, já com o recuo para o padrão. */
  valor: string

  /**
   * O que está no banco, **como está**, mesmo que o back o recuse.
   *
   * 🔴 Existe por um apontamento da revisão do PR 60: com `12` gravado, o
   * efetivo volta `1,2000`. Mostrando só o efetivo, quem quisesse corrigir
   * digitaria `1,2000` — e a tela concluiria que **nada mudou**, deixando o `12`
   * no banco para sempre.
   *
   * ⭐ *A tela mostra o que está gravado, não o que o sistema resolveu.*
   */
  gravado: string | null
  /**
   * Ninguém gravou — vale o padrão da decisão. ⚠️ Um valor gravado que o back
   * **recusa** também chega assim: quem digitou `12` precisa ver que não é isso
   * que está valendo.
   */
  deFabrica: boolean
  minimo: string
  maximo: string
  atualizadoEm: string | null
  atualizadoPor: string | null
}

export const embalagens = {
  listar: () => api.get<EmbalagemDaFamilia[]>('/transporte/embalagens'),

  /** Valor vazio apaga o cadastro e devolve a família ao padrão geral. */
  gravar: (familia: string, valor: string | null) =>
    api.put<{ familia: string; valor: string | null }>(
      `/transporte/embalagens/${encodeURIComponent(familia)}`,
      { valor },
    ),

  multiplicador: () => api.get<MultiplicadorDoFrete>('/transporte/multiplicador'),

  /** Vazio volta ao padrão de fábrica (1,2000). */
  gravarMultiplicador: (valor: string | null) =>
    api.put<{ valor: string }>('/transporte/multiplicador', { valor }),
}
